<template>
  <div class="register-container">
    <div class="register-card">
      <h2 class="title">用户注册</h2>
      <el-form  
        :model="formData"
        :rules="rules" 
        ref="userForm"
        label-width="80px"
        class="register-form">
        <el-form-item style="margin-bottom: 0px;" label="账号" prop="username">
                <input
                  v-model="formData.username"
                  type="text"
                  style="width: 100%;"
                  placeholder="请输入用户名"
                  class="form-input"
                >
          </el-form-item>
          <el-form-item style="margin-bottom: 0px;" label="客户名称" prop="customerName">
                <input
                  v-model="formData.customerName"
                  type="text"
                  style="width: 100%;"
                  placeholder="请输入客户名称"
                  class="form-input"
                >
          </el-form-item>
           <el-form-item style="margin-bottom: 0px;" label="客户单位" prop="customerUnit">
                <input
                  v-model="formData.customerUnit"
                  type="text"
                  style="width: 100%;"
                  placeholder="请输入客户单位"
                  class="form-input"
                >
          </el-form-item>
        <el-form-item style="margin-bottom: 0px;width: 100%;" label="密码" prop="password">
                 <input
                    :type="showPwd ? 'text' : 'password'"
                    style="width: 100%;"
                    v-model="formData.password"
                    placeholder="请输入密码"
                    class="form-input"
                  >
                  <button type="button" class="pwd-btn" @click="showPwd = !showPwd">
                    {{ showPwd ? '隐藏' : '显示' }}
                  </button>
              </el-form-item>
        <el-form-item style="margin-bottom: 0px;width: 100%;" label="确认密码" prop="loginPasswordArgen">
                 <input
                    :type="showPwd ? 'text' : 'password'"
                    style="width: 100%;"
                    v-model="formData.loginPasswordArgen"
                    placeholder="请再次输入密码"
                    class="form-input"
                  >
                  <button type="button" class="pwd-btn" @click="showPwd = !showPwd">
                    {{ showPwd ? '隐藏' : '显示' }}
                  </button>
              </el-form-item>
        <button
          type="submit"
          class="submit-btn"
          :disabled="loading"
          @click="handleSubmit"
        >
          {{ loading ? '注册中...' : '完成注册' }}
        </button>
        <p class="login-link">已有账号？<a @click="goToLogin">立即登录</a></p>
      </el-form>
    </div>
  </div>
</template>

<script>
import { createAccount } from '@/api/account';
import { Message } from "element-ui";
import { encryptData } from '@/utils/encrypt'
export default {
  name: 'Register',
  data() {
    return {
      formData: {
        accountType:'CUSTOMER'
      },
      showPwd: false,
      showConfirmPwd: false,
      loading: false,
      rules: {
            username: { required: true, message: "请输登录账号", trigger: "blur" },
            password: { required: true, message: "请输登录密码", trigger: "blur" },
            loginPasswordArgen:{ required: true, message: "请输再次登录密码", trigger: "blur" },
            customerName:{ required: true, message: "请输客户名称", trigger: "blur" },
            customerUnit:{ required: true, message: "请输客户单位", trigger: "blur" },
       },
    }
  },
  methods: {
    /**
     * 表单提交处理
     */
    async handleSubmit() {
         this.$refs.userForm.validate((valid) => {
            if (valid) {
              if(this.formData.password == this.formData.loginPasswordArgen){
                  let query = JSON.parse(JSON.stringify(this.formData))
                  query.password = encryptData(query.password)
                  createAccount(query).then((res)=>{
                    if(res.code == 200){
                        this.goToLogin()
                    }
                  })
              }else{
                  Message.error("两次密码不一致");
              }
            }
          });
    },

    /**
     * 跳转到登录页面
     */
    goToLogin() {
      location.href = 'http://localhost:8080/#/login'
    }
  }
}
</script>

<style scoped>
.register-container {
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(135deg, #2c3e50 0%, #4a69bd 100%); 
  height: 90vh; 
}
.register-card {
  width: 490px;
  padding: 40px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
}
.title {
  text-align: center;
  color: #333;
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 20px;
}
.register-form {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.form-item {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.form-label {
  font-size: 14px;
  color: #666;
  font-weight: 500;
}
.form-input {
  height: 44px;
  padding: 0 15px;
  border: 1px solid #dcdfe6;
  border-radius: 6px;
  font-size: 14px;
  outline: none;
  transition: all 0.3s;
}
.form-input:focus {
  border-color: #409eff;
  box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
}
.form-input.invalid {
  border-color: #f56c6c;
}
.error-tip {
  font-size: 12px;
  color: #f56c6c;
  line-height: 1;
}
.password-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}
.pwd-btn {
  position: absolute;
  right: 10px;
  border: none;
  background: none;
  color: #909399;
  font-size: 12px;
  cursor: pointer;
}
.submit-btn {
  height: 46px;
  border: none;
  border-radius: 6px;
  background-color: #409eff;
  color: #fff;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.3s;
  margin-top: 20px;
}

.submit-btn:disabled {
  background-color: #a0cfff;
  cursor: not-allowed;
}

.submit-btn:hover:not(:disabled) {
  background-color: #66b1ff;
}
.login-link {
  text-align: center;
  font-size: 14px;
  color: #666;
  margin: 0;
}

.login-link a {
  color: #409eff;
  cursor: pointer;
  text-decoration: none;
}

.login-link a:hover {
  text-decoration: underline;
}
</style>